import { TrackingEventName } from '@/models/analytics/eventTypes';

import { track } from '@/lib/analytics/track';
import { extractDeviceModel } from '@/utils/chronicle/device-helpers';

interface DeviceInfo {
  deviceId: string | null;
  deviceName: string | null;
}

export function trackFirmwareUpgradeStarted({
  deviceId,
  deviceName,
  currentFirmwareVersion,
  targetFirmwareVersion,
  updateSource,
}: DeviceInfo & {
  currentFirmwareVersion: string | null;
  targetFirmwareVersion: string | null;
  updateSource: 'remote' | 'local';
}): void {
  track({
    event_name: TrackingEventName.NativeFirmwareUpgradeStart,
    props: {
      device_id: deviceId ?? undefined,
      device_name: deviceName ?? undefined,
      device_model: extractDeviceModel(deviceName),
      current_firmware_version: currentFirmwareVersion ?? undefined,
      target_firmware_version: targetFirmwareVersion ?? undefined,
      update_source: updateSource,
    },
    // APP-6285: also send to PostHog (was Datadog/Snowplow/Amplitude only).
    options: { posthog: true },
  });
}

export function trackFirmwareUpgradeCompleted({
  deviceId,
  deviceName,
  targetFirmwareVersion,
}: DeviceInfo & {
  targetFirmwareVersion: string | null;
}): void {
  track({
    event_name: TrackingEventName.NativeFirmwareUpgradeComplete,
    props: {
      device_id: deviceId ?? undefined,
      device_name: deviceName ?? undefined,
      device_model: extractDeviceModel(deviceName),
      target_firmware_version: targetFirmwareVersion ?? undefined,
    },
    // APP-6285: also send to PostHog (was Datadog/Snowplow/Amplitude only).
    options: { posthog: true },
  });
}

export function trackFirmwareUpgradeFailed({
  deviceId,
  deviceName,
  targetFirmwareVersion,
  errorCode,
  errorMessage,
  isRetryable,
}: DeviceInfo & {
  targetFirmwareVersion: string | null;
  errorCode: string;
  errorMessage: string;
  isRetryable: boolean;
}): void {
  track({
    event_name: TrackingEventName.NativeFirmwareUpgradeFailed,
    props: {
      device_id: deviceId ?? undefined,
      device_name: deviceName ?? undefined,
      device_model: extractDeviceModel(deviceName),
      target_firmware_version: targetFirmwareVersion ?? undefined,
      error_code: errorCode,
      error_message: errorMessage,
      is_retryable: isRetryable,
    },
    // APP-6285: also send to PostHog (was Datadog/Snowplow/Amplitude only).
    options: { posthog: true },
  });
}
